import { normaliseMoneyAmount } from '../../helpers/presentation/normaliseMoneyAmount';

import type { LocalisationHelpers } from '../../../../bootstrap/localisation';
import type { SkyscannerCommonV1Money } from '@skyscanner-internal/michelin-web-http-client';

export const formatMoney = (
  money: SkyscannerCommonV1Money.Money | undefined,
  formatCurrency: LocalisationHelpers['formatCurrency'],
): string => {
  const amount = normaliseMoneyAmount(money);

  return amount == null ? '' : formatCurrency(amount);
};

export const buildRoute = (
  departure: string | undefined,
  arrival: string | undefined,
): string => [departure, arrival].filter(Boolean).join(' - ');

export const getPricePerDay = (
  price: SkyscannerCommonV1Money.Money | undefined,
  days: number,
): SkyscannerCommonV1Money.Money | undefined =>
  days > 0 && price?.amount
    ? {
        ...price,
        amount: String(Number.parseFloat(price.amount) / days),
      }
    : price;
